import {resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import DoctorsService from "@services/DoctorsService";

export const initialCreateDoctor = {
  name: "",
  avatar_type: "",
  gender_type: "",
  main_type: "",
  experience: "",
  medical_type: "",
  priorities: "",
  intensity: "",
  drug_preference: "",
  decision_making: "",
  activity: "",
  speciality: "",
  backstory: "",
  error: "",
  serverStatus: "",
};

export const DOCTOR_ENUMS = {
  avatar_type: ["male_60", "female_40"],
  gender_type: ["male", "female"],
  main_type: ["simple", "caring", "ambitious", "analyst"],
  experience: ["new", "experienced", "expert"],
  medical_type: [
    "municipal_polyclinic",
    "commercial_polyclinic",
    "municipal_hospital",
    "commercial_hospital",
  ],
  priorities: ["career", "balanced", "community"],
  intensity: ["low", "medium", "high"],
  drug_preference: ["original", "generic"],
  decision_making: [
    "opinion_leaders",
    "colleagues",
    "official_guidelines",
    "scientific_research",
    "clinical_experience",
  ],
  speciality: [
    "cardiologist",
    "dentist",
    "dermatologist",
    "endocrinologist",
    "gastroenterologist",
    "gynecologist",
    "neurologist",
    "oncologist",
    "ophthalmologist",
    "otolaryngologist",
    "pediatrician",
    "psychiatrist",
    "rheumatologist",
    "surgeon",
    "therapist",
    "urologist",
  ],
  activity: ["inactive", "active"],
};

export const postCreateDoctor = createAsyncThunk(
  "doctor/create",
  async ({doctor}, {rejectWithValue}) => {
    try {
      await DoctorsService.createDoctor({doctor});
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  isDoctorCreate: false,
  saveDoctorCreate: false,
  isChanged: false,
  error: "",
  errors: null,
  serverStatus: "",
  createDoctor: initialCreateDoctor,
};

const createDoctorSlice = createSlice({
  name: "create-doctor",
  initialState,
  reducers: {
    setIsDoctorCreate(state, action) {
      state.isDoctorCreate = action.payload;
    },
    setSaveDoctorCreate(state, action) {
      state.saveDoctorCreate = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setIsChanged(state, action) {
      state.isChanged = action.payload;
    },
    setServerStatus(state, action) {
      state.serverStatus = action.payload;
    },
    setCreateDoctor(state, action) {
      state.createDoctor = action.payload;
    },
    clearCreateDoctor() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postCreateDoctor.pending, (state) => {
        state.serverStatus = "loading";
        state.error = "";
        state.errors = null;
      })
      .addCase(postCreateDoctor.fulfilled, (state) => {
        state.error = "";
        state.errors = null;
        state.serverStatus = "success";
      })
      .addCase(postCreateDoctor.rejected, (state, action) => {
        state.error = action.payload.message || "Don`t create doctor!";
        state.errors = action.payload.errors;
        state.serverStatus = "error";
      });
  },
});

export const {
  setIsDoctorCreate,
  setCreateDoctor,
  setSaveDoctorCreate,
  setIsChanged,
  setError,
  setServerStatus,
  clearCreateDoctor,
} = createDoctorSlice.actions;
export default createDoctorSlice.reducer;
